import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { ListProductReferenceEntity } from '../models';

import {
  loadListProductReferences,
  resetProductReferenceEntities,
  upsertListProductReferenceEntity,
  upsertManyListProductReferenceEntities,
} from './list-product-reference-entities.actions';

export interface State extends EntityState<ListProductReferenceEntity> {}

const adapter = createEntityAdapter<ListProductReferenceEntity>({
  selectId: (entity) => entity.listId,
});

export const initialState = adapter.getInitialState();

export const reducer = createReducer<State>(
  initialState,
  on(loadListProductReferences, (state, { productListId }) =>
    adapter.upsertOne(
      { listId: productListId, loading: true, error: undefined },
      state,
    ),
  ),
  on(upsertListProductReferenceEntity, (state, { productReferenceEntity }) =>
    adapter.upsertOne(productReferenceEntity, state),
  ),
  on(
    upsertManyListProductReferenceEntities,
    (state, { productReferenceEntities }) =>
      adapter.upsertMany(productReferenceEntities, state),
  ),
  on(resetProductReferenceEntities, () => adapter.getInitialState()),
);
